import { InitPage } from "../index";

declare let selectedTransfers: any;

class TransferIn {
  selectedTransfers = [];
  init() {
    $("#select_all").on("change", function (e) {
      // @ts-ignore
      const checked = e.target.checked;
      $('input[type="checkbox"].transfers-checkbox:not(:disabled)').prop(
        "checked",
        checked,
      );
      $(".transfers-checkbox").trigger("change");
    });

    $(".transfers-checkbox").on("change", function () {
      var el = $(this);
      if ($(el).is(":checked") == true) {
        selectedTransfers.push(el.data("id"));
        $("#bulk-close-btn").removeClass("disabled");
      } else {
        selectedTransfers = selectedTransfers.filter(function (value) {
          return value !== el.data("id");
        });

        if (selectedTransfers.length == 0) {
          $("#bulk-close-btn").addClass("disabled");
        }
      }

      $("#select_all").prop(
        "checked",
        $('input[type="checkbox"].transfers-checkbox:not(:disabled)').length ===
          $(".transfers-checkbox:checked").length,
      );
    });

    $(document).on("click", "#bulk-close-btn", function (e) {
      e.preventDefault(); // Prevent default link behavior

      const selectedIds = $(".transfers-checkbox:checked")
        .map(function () {
          return $(this).val();
        })
        .get();

      if (selectedIds.length === 0) {
        alert("Please select at least one item.");
        return;
      }

      const url = $(this).attr("href");

      $.ajax({
        url: url,
        method: "GET",
        data: { id: selectedIds },
        dataType: "script",
      });
    });
  }
}

export function LoadPage() {
  InitPage("transfer_in", () => {
    const transfer_in = new TransferIn();
    transfer_in.init();
  });
}
